<template>
    <v-card
        elevation="0"
        v-if="skin.id"
    >
        <v-row justify="center" align="top" class="f-row">
            <v-img
                data-cy="choose-skin-item"
                :src="`https://assets.beeverso.org/skins/${getThumbnail(skin)}`"
                class="skin-img border-radius-3 transition-all mx-2 cursor-pointer"
                :max-width="!$vuetify.breakpoint.xs ? '145' : '100'"
                :max-height="!$vuetify.breakpoint.xs ? '145' : '100'"
                @click="setToBuySkin"
                @load="handleLoaded"
                @mouseover="hover = true"
                @mouseleave="hover = false"
                alt="Skin"
            >
                <!-- <v-overlay absolute opacity="0" style="cursor:pointer;">
                    <v-img :src="favoriteSrc" class="mt-3 bg-orange border-radius-5" height="50" max-width="60" v-show="hover"></v-img>
                </v-overlay> -->
            </v-img>
            <v-skeleton-loader
                v-if="!loaded"
                class="skeleton-skin-img border-radius-3 position-absolute opacity-none"
                height="160"
                width="200"
                type="image"
                :transition="'scale-transition'"
            />
        </v-row>
        <v-row justify="center" class="">
            <v-chip
                label
                color="white"
                class="px-1 font-weight-bold user-purchased-chip"
                @click="setToBuySkin"
                v-if="!skin.purchased"
            >
                <v-img
                    :src="require('@/assets/img/icons/beecoins.png')"
                    height="28"
                    width="28">
                </v-img>
                <span class="line-height-100">{{ skin.price }}</span>
            </v-chip>
            <v-chip
                label
                color="white"
                class="px-1 font-weight-bold user-purchased-chip"
                v-else
            >
                <v-img
                    :src="require('@/assets/img/icons/check-stroke.png')"
                    height="32"
                    width="32">
                </v-img>
            </v-chip>
        </v-row>
        <!-- <v-row justify="center" class="my-2" v-show="!devPending">
            <v-img
                src="/img/user/star-filled.svg"
                class="mx-1"
                max-height="15"
                max-width="15"
                v-for="n in [0,1,2,3]"
                :key="n + '-filled'"
            />
            <v-img
                src="/img/user/star.svg"
                class="mx-1"
                max-height="15"
                max-width="15"
            />
        </v-row> -->
        <!-- <v-row justify="center" class="my-2 color-text">
            {{ skin.name }}
        </v-row> -->
    </v-card>
</template>

<script>

import { mapState } from 'vuex'
import SkinFavoriteService from '../../services/skinFavorite'

const defaultSkin = {
    active: true,
    favorite: false,
    id: 0,
    name: "",
    price: 0,
    purchased: false,
    resources: []
}

export default {
    props: {
        skin: {
            type: Object,
            default: defaultSkin,
        }
    },
    data() {
        return {
            devPending: true,
            hover: false,
            loaded: false,
            favorite: false
        }
    },
    mounted() {
        this.favorite = this.skin.favorite
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        favoriteSrc() {
            return this.favorite ? '/img/user/icon-favorite-selected.svg' : '/img/user/icon-favorite.svg'
        }
    },
    methods: {
        getThumbnail(skin) {
            const img = skin.resources.find((res) => res.resourceUrl.includes('thumbnail'))
            return img.resourceUrl
        },
        handleLoaded() {
            this.loaded = true
        },
        setFavorite () {
            this.favorite = !this.favorite
            this.$emit('favorite',
                { id: this.skin.id, favorite: this.favorite }
            )
            if (this.favorite) {
                SkinFavoriteService.createFavorite(
                    this.user.id,
                    this.skin.id
                )
                .catch((error) => console.error(error))
            } else {
                SkinFavoriteService.deleteFavorite(
                    this.user.id,
                    this.skin.id
                )
                .catch((error) => console.error(error))
            }
        },
        setToBuySkin() {
            this.$emit('toBuy', this.skin)
        }
    }
}
</script>

<style lang="css" scoped>
.color-text {
    color: #4A3216;
}
.f-row {
    height: 50%;
}
.skin-img {
    display: block;
    height: 100%;
    width: 50%;
}
.skeleton-skin-img {
    margin-top: -5px;
}
.skin-to-buy {
    opacity: 0.3;
}
.margin-top {
    margin-top: -100px;
}
.v-chip.user-purchased-chip{
    border: 1px solid #F0F2F4!important;
    background-color: #f0f2f4bb!important;
    position: absolute;
    bottom: -24px;
    z-index: 1;
    @media screen and (min-width: 600px) {
        height: 40px;
        font-size: 1em;
    }
}
</style>
